import { ApplicationConfig } from "@angular/core";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideAuth0 } from "@auth0/auth0-angular";

export const appConfig: ApplicationConfig = {
    providers: [
        provideAnimationsAsync(),
        provideAuth0({
          domain: 'golftech.us.auth0.com',
          clientId: 'TrkEZ8VEWdPeMB1B93vWZ4K1jD4w0IkE',
          authorizationParams: {
            redirect_uri: window.location.origin + "/index.html"
          }
        })
      ]
};
